import { DqSidePanel, DqSidePanelContent } from "@decentriq/components";
import { useDatasetByHashQuery } from "@decentriq/graphql/dist/hooks";
import { Divider } from "@mui/joy";
import { Fragment, memo } from "react";
import { DatasetTabs } from "features/datasets/components";
import { DatasetPermissionWrapper } from "features/datasets/wrappers";
import DatasetDrawerTitle from "./DatasetDrawerTitle";

interface DatasetDrawerProps {
  open: boolean;
  manifestHash: string | null;
  onClose: () => void;
}

const DatasetDrawer = memo<DatasetDrawerProps>(
  ({ open, onClose, manifestHash }) => {
    const { data } = useDatasetByHashQuery({
      skip: !manifestHash || !open,
      variables: { manifestHash: manifestHash! },
    });
    const datasetName = data?.datasetByManifestHash.name;
    return (
      <DqSidePanel.Floating onClose={onClose} open={open}>
        <DatasetPermissionWrapper
          manifestHash={manifestHash!}
          skipFetching={!data || !open}
        >
          <Fragment>
            {open && data ? (
              <Fragment>
                <DatasetDrawerTitle
                  datasetName={datasetName}
                  manifestHash={manifestHash!}
                  onClose={onClose}
                />
                <Divider inset="context" />
              </Fragment>
            ) : null}
            <DqSidePanelContent>
              {open && data ? (
                <DatasetTabs
                  manifestHash={data.datasetByManifestHash.manifestHash}
                  skipFetching={false}
                />
              ) : null}
            </DqSidePanelContent>
          </Fragment>
        </DatasetPermissionWrapper>
      </DqSidePanel.Floating>
    );
  }
);

DatasetDrawer.displayName = "DatasetDrawer";

export default DatasetDrawer;
